import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getClassDistributionReportActionHandler,
  getShotClassUserReportActionHandler,
  getTrainingTypesActionHandler,
  sendRemainderActionHandler,
} from "../../../../store/actions/actionHandlers/reportActionHandler";
import Dropdown from "../../../../components/Common/ReactForm/Dropdown/Dropdown";
import { useNavigate } from "react-router";
import { useFetchData } from "../../../../hooks/useFetchData";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import classes from "./ClassTabularReport.module.scss";
import { classTabularReport } from "../../../../utils/mainTabs/reports/tabularReport/classTabularReport";
import Button from "../../../../components/Common/Button/Button";
import { classTabularModalReport } from "../../../../utils/mainTabs/reports/tabularReport/classTabularModalReport";
import Modal from "../../../../components/Common/Modal/Modal";
import { useCallback } from "react";
import { errorTypes } from "../../../../utils/errorTypes";
import moment from "moment";
import { setErrorAction } from "../../../../store/actions/actionCreators/errorActionCreator";
import NoDataFoundIcon from "../../../../components/Common/SvgIcons/ReportIcons/NoDataFoundIcon";
import { FormattedMessage, injectIntl } from "react-intl";
import Input from "../../../../components/Common/Input/Input";
import { userTabularReportSchema } from "../UserTabularReportPage/UserTabularReport";
import { FormProvider, useForm } from "react-hook-form";
import { dateFormatyyyymmdd } from "../../../SocialPage/PollManagement/DistributePoll/DistributePollForm/DistributePollForm";
import { yupResolver } from "@hookform/resolvers/yup";
import useFeatureChecks from "../../../../hooks/useFeatureChecks";
import { featureList } from "../../../../utils/featureList";

const ClassTabularReport = ({ intl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const methods = useForm({
    resolver: yupResolver(userTabularReportSchema),
    defaultValues: {
      userName: "",
      fromDate: "",
      toDate: "",
    },
  });
  const { reset } = methods;
  const pageSize = 20;
  const pageNumber = 1;
  const { columns } = classTabularReport;
  const reportState = useSelector((state) => state.reportReducer);
  const { trainingTypes } = reportState;
  const [trainingTypesOptions, setTrainingTypesOptions] = useState(["none"]);
  const [fromDate, setFromDate] = useState("none");
  const [toDate, setToDate] = useState("none");
  const [className, setclassName] = useState("none");
  const [selectedTrainings, setSelctedTrainings] = useState("none");
  const [reportMode, setReportMode] = useState("View");
  const [classId, setClassId] = useState(0);
  const [tableColumns, setTableColumns] = useState([]);
  const [loader, setLoader] = useState(false);
  const [fromMinDate, setFromMinDate] = useState(null);
  const [toMinDate, setToMinDate] = useState(null);
  const [fromMaxDate, setFromMaxDate] = useState(
    dateFormatyyyymmdd(new Date())
  );
  const [toMaxDate, setToMaxDate] = useState(dateFormatyyyymmdd(new Date()));
  const [selectedTrainingIds, setSelectedTrainingIds] = useState("none");

  const { columns: modalColumns } = classTabularModalReport;
  const { checkMSOMFeature } = useFeatureChecks();
  const menu = {
    roleMenu: "",
    MSOMMenu: featureList?.EMAIL_REMINDER,
  };

  useEffect(() => {
    const trainingOptions = trainingTypes?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    setTrainingTypesOptions(trainingOptions);
  }, [trainingTypes]);

  const onTrainingSelected = (selected) => {
    let trainingTypeSelected = "";
    selected?.forEach((data, index) => {
      trainingTypeSelected = `${trainingTypeSelected + data?.value}${
        selected?.length !== index + 1 ? "," : ""
      }`;
    });
    setSelectedTrainingIds(trainingTypeSelected);
    setSelctedTrainings(selected);
  };

  useEffect(() => {
    dispatch(getTrainingTypesActionHandler());
  }, [dispatch]);

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setClassDistributionReport,
      setTempClassDistributionReport,
      setTotalRows
    ) =>
      getClassDistributionReportActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setClassDistributionReport,
        setTempClassDistributionReport,
        setTotalRows,
        className,
        fromDate,
        toDate,
        selectedTrainingIds,
        reportMode,
        setLoader
      ),
    pageSize
  );

  const {
    data: modalData,
    setData: setModalData,
    updatedData: updatedModalData,
    setUpdatedData: setModalUpdatedData,
    totalRows: setModalTotalRows,
    handleCurrentPage: handlerModalCurrentPage,
    handleSearchQuery: handleModalSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setUserShotClassReport,
      setTempUserShotClassReport,
      setTotalRows
    ) =>
      getShotClassUserReportActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setUserShotClassReport,
        setTempUserShotClassReport,
        setTotalRows,
        fromDate,
        reportMode,
        classId,
        toDate,
        selectedTrainings
      ),
    pageSize
  );

  const { SUCCESS, FAIL, WARN } = errorTypes;

  const handleEmailReminder = (classId) => {
    dispatch(
      setErrorAction(
        "SUCCESS",
        "Email has been send to active user who have not completed the class"
      )
    );

    dispatch(sendRemainderActionHandler(classId));
  };

  let userClassName;
  data?.map((i) => {
    if (i.ClassId === classId) {
      userClassName = i.ClassName;
    }
  });

  const handleUserClassData = () => {
    handleUserPopUp(0);
  };

  const handleUserPopUp = useCallback((classId) => {
    setClassId(classId);
    handleModalSearchQuery("");
  }, []);

  useEffect(() => {
    let newTableColumns = columns(
      navigate,
      handleUserPopUp,
      handleEmailReminder
    );
    const isEmailReminder = checkMSOMFeature(menu);
    // debugger;
    if (isEmailReminder) setTableColumns(newTableColumns);
    else {
      setTableColumns(
        newTableColumns?.filter((col) => col.fieldName !== "Email")
      );
    }
  }, [columns, navigate, handleUserPopUp]);

  const onInputChange = (e) => {
    if (e.target.value) setclassName(e.target.value);
    else setclassName("none");
  };

  const onFilterSearch = () => {
    handleSearchQuery();
  };

  const handleReset = () => {
    setclassName("none");
    setSelctedTrainings("none");
    setFromDate("none");
    setToDate("none");
    setToMinDate();
    setFromMinDate();
    setFromMaxDate(dateFormatyyyymmdd(new Date()));
    setToMaxDate(dateFormatyyyymmdd(new Date()));
    handleSearchQuery();
    setSelectedTrainingIds("none");
    reset();
    setUpdatedTrainingList(trainingTypes);
  };

  const onFromDateChange = (date) => {
    if (date.target.value) setToMinDate(date.target.value);
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    setFromDate(encodeURIComponent(newDate + ""));
  };

  const onToDateChange = (date) => {
    if (date.target.value) setFromMaxDate(date.target.value);
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    setToDate(encodeURIComponent(newDate + ""));
  };

  const handleClick = () => {
    dispatch(
      getClassDistributionReportActionHandler(
        "",
        pageNumber,
        pageSize,
        "",
        "",
        "",
        className,
        fromDate,
        toDate,
        selectedTrainings,
        "Extract"
      )
    );
  };

  const handleModalClick = () => {
    dispatch(
      getShotClassUserReportActionHandler(
        "",
        pageNumber,
        pageSize,
        "",
        "",
        "",
        fromDate,
        "Extract",
        classId,
        toDate,
        selectedTrainings
      )
    );
  };

  //mukesh Training Types

  const [trainingTypesList, setTrainingTypesList] = useState([]);
  let setUpdatedTrainingList = useCallback(
    (trainingTypes) => {
      if (trainingTypes?.length > 0) {
        let updatedUserGroup = trainingTypes.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setTrainingTypesList(updatedUserGroup);
      }
    },
    [trainingTypes, trainingTypesList]
  );
  useEffect(() => {
    setUpdatedTrainingList(trainingTypes);
  }, [dispatch, trainingTypes]);

  useEffect(() => {
    if (trainingTypesList.length > 0) {
      const filtered = trainingTypesList.filter((item) => {
        return item.checked === true;
      });
      if (filtered.length > 0) {
        let updateFilteredResult = filtered.map((item) => {
          return { label: item.Name, value: item.TypeId };
        });
        setSelctedTrainings(updateFilteredResult);
        let trainingTypeSelected = "";
        filtered?.forEach((data, index) => {
          trainingTypeSelected = `${trainingTypeSelected + data?.TypeId}${
            filtered?.length !== index + 1 ? "," : ""
          }`;
        });
        setSelectedTrainingIds(trainingTypeSelected);
        setSelctedTrainings(trainingTypeSelected);
      }
    }
  }, [trainingTypesList, setSelctedTrainings]);

  return (
    <>
      <div className={classes.reportFilter_Main}>
        <FormProvider {...methods}>
          <div className={classes.reportFilter_userCLass}>
            <Input
              label={<FormattedMessage id="CLASS_NAME_TEXT" />}
              placeholder={intl.formatMessage({
                id: `MostClassX_axis`,
              })}
              type={"text"}
              onChange={onInputChange}
              name="userName"
              width="25"
            />
            <Input
              label={"From Date"}
              type={"date"}
              onChange={onFromDateChange}
              name="fromDate"
              width="25"
              min={fromMinDate}
              max={fromMaxDate}
            />
            <Input
              label={"To Date"}
              type={"date"}
              onChange={onToDateChange}
              name="toDate"
              min={toMinDate}
              max={toMaxDate}
              width="25"
            />
            <div className={classes.trainingType}>
              {/* <Dropdown
                label={<FormattedMessage id="TRAINING_TYPE" />}
                isMulti
                defaultValue={selectedTrainings}
                placeholder="Enter Training"
                options={trainingTypesOptions}
                onChange={onTrainingSelected}
                selectedValue={selectedTrainings}
              /> */}
              <Input
                label={<FormattedMessage id="TRAINING_TYPE" />}
                name="TrainingTypes"
                type="noSearchTags"
                fieldName={"Name"}
                fieldValue="TypeId"
                placeholder="Search Training Type"
                // labelMsg="(Max: 15 Training Types)"
                height="3.9"
                width="24.5"
                labelColor={"#404040"}
                searchable={true}
                id={"TypeId"}
                searchTagsList={trainingTypesList}
                handleTagList={(tagsList) => {
                  setTrainingTypesList(tagsList);
                }}
                // error={errors?.TrainingTypes?.message}
              />
            </div>
          </div>
          <div className={classes.searchResetButton}>
            <span
              style={{
                textDecoration: "underline",
                color: "#0051BC",
                cursor: "pointer",
                paddingTop: "10px",
              }}
              onClick={handleReset}
            >
              <FormattedMessage id="RESET_MSG" />
            </span>
            <Button
              label={<FormattedMessage id="P_Search" />}
              dark
              small
              className={classes.searchButton}
              onClick={onFilterSearch}
            />
          </div>
        </FormProvider>
      </div>
      <div className={classes.tabularDataTable}>
        <DataTable
          columns={tableColumns}
          defaultData={data}
          setDefaultData={setData}
          data={updatedData}
          setData={setUpdatedData}
          downloadable
          onDownload={handleClick}
          totalRows={totalRows}
          loading={loader}
          uniqueFieldName={"ClassName"}
          // fetchMoreData={handleCurrentPage}
          fetchMoreData={handleCurrentPage}
          // loading={loader}
        />
        <Modal
          handleSubmit={handleUserClassData}
          isOpen={classId}
          heading={"Class Report Details"}
          toggle={() => handleUserPopUp()}
          width={"100"}
          height={"55.9"}
        >
          <div>
            <div className={classes.mainHeadingModal}>
              <h3>Class Name:</h3>{" "}
              <p className={classes.userName}>{userClassName}</p>
            </div>
            <DataTable
              columns={modalColumns(navigate)}
              // defaultData={data}
              // setDefaultData={setData}
              data={modalData}
              // setData={setUpdatedData}
              totalRows={setModalTotalRows}
              uniqueFieldName={"ClassId"}
              downloadable
              onDownload={handleModalClick}
              fetchMoreData={handlerModalCurrentPage}
            />
          </div>
        </Modal>
      </div>
    </>
  );
};

export default injectIntl(ClassTabularReport);
